import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

/**
 * Contains style information for the new snag form.
 */
export const NewSnagFormStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        flex: "1",
        flexDirection: "column",
        height: "100%",
        "& > form": {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            "& .dropzoneBox > div": {
                borderRadius: "3px",
                background: "transparent",
                minHeight: "60px",
            },
        },
        "& div.MuiFormControl-root": {
            marginBottom: "16px",
            width: "100%",
        },
        "& div.MuiOutlinedInput-multiline": {
            padding: "8px 10px",
            "& textarea": {
                minHeight: "70px",
            },
        },
        "& button": {
            width: "100%",
        },
    },
    errorText: {
        fontSize: "12px",
        color: "red",
        marginTop: "-24px",
        fontWeight: 500,
        lineHeight: "17px",
        marginBottom: "10px",
    },
    selectionRow: {},
    textAreaRow: {},
    buttonRow: {
        marginTop: "20px",
        "& > button": {
            background: "#449B23",
            padding: "12px 20px",
            borderRadius: "30px",
            fontSize: "14px",
            lineHeight: "16px",
            fontWeight: 400,
            color: "#fff",
            boxShadow: "none",
            letterSpacing: "-0.35px",
            "&:hover": {
                background: "#408c23d4",
                boxShadow: "none",
            },
        },
    },
    formControl: {
        marginBottom: "26px !important",
        "& > div": {
            borderRadius: "3px",
        },
    },
    formInputControl: {},
    formTextAreaControl: {},
    submitButton: {},
    reportModalAttechedImagesRow: {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        gap: "30px",
        "& > div": {
            width: "45%",
        },
    },

    selectionCol: {
        display: "flex",
        flex: "1",

        flexDirection: "column",
    },

    textAreaCol: {
        display: "flex",
        flex: "1",

        flexDirection: "column",
        "& > div": {
            flex: 1,
        },
    },
}));
